<template lang="pug">
  div.stamp(:style="`padding: ${stampPadding}`")
    div.text-sm.font-semibold.no-wrap {{ stampNumber }}
</template>

<script>
export default {
  props: {
    stampNumber: {
      type: Number,
      default: 0
    },
    paddingTop: {
      type: String,
      default: '5px'
    },
    paddingBottom: {
      type: String,
      default: '5px'
    },
    paddingLeft: {
      type: String,
      default: '11px'
    },
    paddingRight: {
      type: String,
      default: '11px'
    },
  },
  computed: {
    stampPadding () {
      return `${this.paddingTop} ${this.paddingRight} ${this.paddingBottom} ${this.paddingLeft}`
    }
  },
}
</script>

<style scoped>
.stamp {
  width: 35px;
  height: 35px;
  border-radius: 50% !important;
  border: 2px #848484 dashed;
  color: #848484;
}
</style>